import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import { SR_API_ACTION_UTILITY_PARTNER_SYNC_PM_SOFTWARE } from 'api/utilityActionTypes';

import { createInitialValues, createFormValidationFn } from 'client/helpers/formikHelpers';

import useDispatch from 'client/hooks/useDispatch';
import requestUtilityApi from 'client/actions/requestUtilityApi';

import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_GREEN,
  SR_BUTTON_HEIGHT_MEDIUM,
} from 'client/components/SrButton/SrButton';
import SrBox from 'client/components/SrBox';

const getFormFields = ({ utilityPartnerPMSoftwareIntegrationList }) => {
  return [
    {
      id: 'utilityPartnerPMSoftwareIntegrationId',
      type: 'select',
      title: 'PM Software Integration',
      properties: {
        choices: utilityPartnerPMSoftwareIntegrationList.map(
          ({ id, partnerName, pmSoftwareName }) => ({
            label: `${partnerName} - ${pmSoftwareName}`,
            value: id,
          }),
        ),
        transformToNumber: true,
      },
      validations: ['required'],
    },
  ];
};

const UPPartnerSyncPMSoftwareForm = ({ utilityPartnerPMSoftwareIntegrationList }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();
  const formFields = getFormFields({ utilityPartnerPMSoftwareIntegrationList });

  const onSubmit = (formValues, formikBag) => {
    setIsSubmitting(true);
    dispatch(requestUtilityApi, {
      action: SR_API_ACTION_UTILITY_PARTNER_SYNC_PM_SOFTWARE,
      payload: {
        ...formValues,
      },
      onSuccess() {
        formikBag.resetForm();
        global.alert('Done.');
      },
      onError(error) {
        global.alert(error?.message);
      },
    });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={createInitialValues({ formFields })}
      validate={createFormValidationFn(formFields)}
      onSubmit={onSubmit}
      render={(formikBag) => (
        <Form>
          {formFields.map((formField) => (
            <SrFormikField
              key={formField.id}
              formField={formField}
              formikBag={formikBag}
              theme={SR_FIELD_THEME_ADOBE}
            />
          ))}
          <SrBox padding="28px 0 12px">
            <SrButton
              theme={SR_BUTTON_THEME_ADOBE_GREEN}
              disabled={!formikBag.isValid || isSubmitting}
              heightType={SR_BUTTON_HEIGHT_MEDIUM}
              hasBoxShadow
              type="submit"
            >
              Submit
            </SrButton>
          </SrBox>
        </Form>
      )}
    />
  );
};

UPPartnerSyncPMSoftwareForm.propTypes = {
  utilityPartnerPMSoftwareIntegrationList: PropTypes.array,
};

UPPartnerSyncPMSoftwareForm.displayName = 'UPPartnerSyncPMSoftwareForm';

export default UPPartnerSyncPMSoftwareForm;
